<!-- 系统版本 -->
<template>
  <basic-container>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="系统版本" name="first">
        <div class="ver">
          <el-timeline>
            <el-timeline-item
              v-for="(item, i) in arr"
              :key="i"
              :timestamp="item.UPD_TIME"
              placement="top"
            >
              <el-card>
                <h4 v-text="item.VER_NO"></h4>
                <p v-text="item.UPD_INIF"></p>
                <el-button v-if="item.UPLOAD" type="primary" size="mini" @click="uploadClick(item.UPLOAD)">上传</el-button>
                <el-button v-if="item.XUNJIAN" type="primary" size="mini" @click="xjClick(item.XUNJIAN)">巡检</el-button>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
        <!-- </basic-container> -->
      </el-tab-pane>
      <el-tab-pane v-if="userInfo.user_id === '1'" label="数据库备份" name="second">
        <!-- <basic-container> -->
        <div class="ver">
          <el-timeline>
            <el-timeline-item
              v-for="(item, i) in arr1"
              :key="i"
              :timestamp="item.BACK_TIME"
              placement="top"
            >
              <el-card>
                <h4 v-for="(it, ind) in item.BACK_FILE.files" :key="ind" style="margin: 5px 0">
                  {{it}}
                  <el-button @click="downloadDBData(it, item.BACK_FILE.savePath)" size="mini" >下载</el-button>
                </h4>
                <span v-text="item.UPD_INIF"></span>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      :visible.sync="fileDialog"
      :append-to-body="true"
      title="上传"
      :close-on-click-modal="false"
      v-dialogdrag
    >
      <el-upload
        class="upload-demo"
        ref="upload"
        action=""
        :on-change="
          (file, fileList) => {
            onChange(file, fileList);
          }
        "
        :on-remove="
          (file, fileList) => {
            handleRemove(file, fileList);
          }
        "
        :file-list="fileList"
        :auto-upload="false"
        multiple
      >
        <el-button size="mini" type="primary">点击上传</el-button>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="saveClick" type="primary" style="margin-right:10px">确定</el-button>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="fileDialog = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="xunjianDialog"
      :append-to-body="true"
      title="巡检"
      width="60%"
      :close-on-click-modal="false"
      @opened="open"
      v-dialogdrag
    >
      <el-row v-for="item in xunjian" :key="item" v-text="item"></el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="xunjianDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </basic-container>
</template>
<script>
import { post, download, get } from "@/api/table/table";
import website from "@/config/website";
import {mapGetters} from "vuex";
export default {
  components: {},
  computed: {...mapGetters(["userInfo"])},
  data() {
    return {
      activeName: "first",
      arr: [
        {
          VER_NO: "前端代码",
          UPD_TIME: website.VersionTime,
          UPD_INIF: website.Version,
        },
      ],
      arr1: [],
      fileDialog:false,
      xunjianDialog:false,
      xunjian:[]
    };
  },
  watch: {},
  inject: ["index"],
  created() {},
  methods: {
    onChange(file,fileList){
      console.log(file,fileList)
      this.fileList = fileList
    },
    handleRemove(file,fileList){
      console.log(file,fileList)
      this.fileList = fileList
    },
    saveClick(){
      let formdata = new FormData()
      formdata.append("file",this.fileList[0].raw);
      post(`/api/${this.url}`,formdata).then(res=>{
        this.$message.success('上传成功')
        this.fileList = []
        this.fileDialog = false
      })
    },
    //巡检
    xjClick(url){
      post(`/api/${url}`).then(res=>{
        console.log(typeof res.data.data);
        if(typeof res.data.data !== "object"){
          this.$message.success('巡检成功');
        }else{
          this.xunjianDialog = true;
          this.xunjian = [];
          for (const key in res.data.data) {
            if (Object.hasOwnProperty.call(res.data.data, key)) {
              const element = res.data.data[key];
              this.xunjian.push(`${key}：${element}`);
            }
          }
        }
      })
    },
    // 巡检弹窗打开
    open(){
      this.$message.success('巡检成功');
    },
    //上传
    uploadClick(url){
      this.fileDialog = true
      this.url = url
    },
    //下载数据库备份文件
    downloadDBData (file, savePath) {
      let url = `/api/blade-fileserver/api/fileserver/downloadBySavename?fileName=${file.split('=')[0]}&filePath=${savePath}/${file.split('=')[0]}`;
      get(url).then( res => {
        this.downloadFun(res.data);
      } )
      // get('')
      // download({
      //   filePath: savePath + '/' + file.split('=')[0],
      //   fileName: file.split('=')[0],
      // }).then( res => {
      //   this.downloadFun(res, file.split('=')[0]);
      //   // this.$message.success('下载成功！')
      // } ).catch( err => {
      //   console.log(err)
      // } )
    },
    downloadFun(res,name){
      const blob = new Blob([res.data], {
        type: 'application/octet-stream'
      })
      let url = window.URL.createObjectURL(res);//为文件流创建构建下载链接
      let link = document.createElement('a');//创建a标签
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download',name);//设置a标签的下载动作和下载文件名
      document.body.appendChild(link);
      link.click();//执行下载
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);//释放标签
    },
    // 获取系统版本号
    onLoad() {
      post("/api/blade-system/usual/api/getServerVersion").then((res) => {
        console.log(res);
        this.arr = this.arr.concat(res.data.data);
      });
      if(this.userInfo.user_id === '1'){
        post("/api/blade-system/usual/api/getDataBackUp").then((res1) => {
          console.log(res1.data.data);
          this.arr1 = this.arr1.concat(res1.data.data);
        });
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
  activated() {
    this.onLoad();
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.ver {
  min-height: 500px;
}
/deep/ .el-tabs__header {
  margin: -5px 0px 15px !important;
}
</style>
